import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-cantab-play',
    templateUrl: './cantab-play.component.html',
    styleUrls: ['./cantab-play.component.scss']
})
export class CantabPlayComponent implements OnInit, OnDestroy {

    constructor(
        private http: HttpService,
        public loading: LoadingService,
        private location: Location
    ) { }
    data: any[] = [];
    numberOfQuiz: number = 1;
    totalQuiz: number = 0;
    percentQuiz: string = '0';
    currentQuiz: any = {};
    currentAnswer: any[] = [];
    assetUrl: any = null;
    point: number = 0;
    elapsedTime: number = 0;
    isDone: boolean = false;
    startTime: number = 0;
    endTime: number = 0;
    countDownInterval: any = null;
    countDown: number = 3;
    numberImage: number = 0;
    showImageInterval: any = null;
    currentImage: any[] = [];
    hasShow: any[] = [];
    correctImage: any[] = [];
    changeImageSpeed: number = 1000;
    idxCorrect: number = 0;
    showCorrectTimeout: any = null;
    correctAnswer: number = 0;
    graphImage: any = null;
    backSound: HTMLAudioElement | null = null;

    async getData(): Promise<void> {
        const r = await this.http.Get('quiz/cantab', {}, true);
        if (!r.success) {
            this.location.back();
            return;
        }
        this.data = r.response?.result?.data || [];
        if (r.response?.result?.sound) {
            this.backSound = new Audio(this.assetUrl + r.response?.result?.sound);
        }
        this.graphImage = r.response?.result?.image || null;
        this.totalQuiz = this.data.length || 1;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.data.sort(() => Math.random() - 0.5);
        this.loading.done();
        this.countDownInterval = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
                this.playQuiz();
                clearInterval(this.countDownInterval);
                if (this.backSound != null) {
                    this.backSound.loop = true;
                    this.backSound.play();
                }
            }
        }, 1000);
    }

    playQuiz(): void {
        this.correctAnswer = 0;
        this.numberImage = 0;
        this.currentQuiz = this.data[this.numberOfQuiz - 1] || {};
        this.currentImage = [];
        this.hasShow = [];
        this.idxCorrect = 0;
        if (this.numberOfQuiz <= 2) {
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[0]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[1]?.image);
        } else if (this.numberOfQuiz <= 4 && this.numberOfQuiz > 2) {
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[2]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[3]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[4]?.image);
        } else if (this.numberOfQuiz <= 6 && this.numberOfQuiz > 4) {
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[5]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[6]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[7]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[8]?.image);
        } else if (this.numberOfQuiz <= 8 && this.numberOfQuiz > 6) {
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[3]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[4]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[5]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[6]?.image);
            this.currentImage[this.getRandomInt(0, 5)] = (this.data[7]?.image);
        } else if (this.numberOfQuiz <= 10 && this.numberOfQuiz > 8) {
            this.currentImage.push(this.data[4]?.image);
            this.currentImage.push(this.data[5]?.image);
            this.currentImage.push(this.data[6]?.image);
            this.currentImage.push(this.data[7]?.image);
            this.currentImage.push(this.data[8]?.image);
            this.currentImage.push(this.data[9]?.image);
        }
        clearInterval(this.showImageInterval);
        this.showImageInterval = setInterval(() => {
            this.numberImage++;
            this.playShuffle();
            if (this.numberImage > 6) {
                clearInterval(this.showImageInterval);
                let cImage = this.currentImage.filter(e => e);
                cImage.sort(() => Math.random() - 0.5);
                this.correctImage = cImage;
                setTimeout(() => {
                    this.startTime = (new Date()).getTime();
                    this.numberImage++;
                }, this.changeImageSpeed);
            }
        }, this.changeImageSpeed);
        this.playAudio();
    }

    nextQuiz(): void {
        this.endTime = (new Date()).getTime();
        this.elapsedTime += (this.endTime - this.startTime);
        if (this.numberOfQuiz >= this.totalQuiz) {
            this.isDone = true;
            this.postResult();
            return;
        }
        this.numberOfQuiz++;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.playQuiz();
    }

    answerQuiz(item: string): void {
        this.playClick();
        if (this.isDone) {
            if (this.backSound != null) {
                this.backSound.pause();
                this.backSound = null;
            }
            this.postResult();
            return;
        }
        this.correctAnswer += (item == this.correctImage[this.idxCorrect]) ? 1 : 0;
        this.idxCorrect++;
        let cImage = this.currentImage.filter(e => e);
        clearTimeout(this.showCorrectTimeout);
        if (this.idxCorrect > cImage.length - 1) {
            this.point += (this.correctAnswer == cImage.length ? this.currentQuiz.point : 0);
            this.nextQuiz();
            return;
        }
        this.numberImage = 7;
        this.showCorrectTimeout = setTimeout(() => {
            this.numberImage++;
        }, this.changeImageSpeed);
    }

    playAudio(): void {
        if (!this.currentQuiz.voice) {
            return;
        }
        let audio = new Audio(this.assetUrl + this.currentQuiz.voice);
        audio.play();
    }

    playClick(): void {
        let audio = new Audio('/assets/click.wav');
        audio.play();
    }

    playShuffle(): void {
        let audio = new Audio('/assets/cantab_shuffle.wav');
        audio.play();
    }

    async postResult(): Promise<void> {
        let seconds = this.elapsedTime;
        let d = new Date(0);
        d.setMilliseconds(seconds);
        let ts = d.toISOString().substring(11, 23) + '000';
        this.http.SaveQuiz('CANTAB', '', this.point, ts);
    }

    ngOnInit(): void {
        this.loading.start();
        this.assetUrl = environment.assetUrl;
        this.getData();
    }

    ngOnDestroy(): void {
        clearInterval(this.countDownInterval);
        clearInterval(this.showImageInterval);
        clearTimeout(this.showCorrectTimeout);
        if (this.backSound != null) {
            this.backSound.pause();
            this.backSound = null;
        }
    }

    getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        let res = Math.floor(Math.random() * (max - min + 1)) + min;
        if (this.hasShow.indexOf(res) > -1) {
            return this.getRandomInt(min, max);
        } else {
            this.hasShow.push(res);
            return res;
        }
    }

}
